module.exports=function(scope){ return `<div class="asseco asseco-mask">
    <div class="mdl-spinner mdl-js-spinner is-active asseco-absolute-center" ${scope.hSpin ? ` style="display: none;"` : ''}></div>
    <div class="asseco-absolute-center asseco-mask-message">
        ${scope.msg}
    </div>
</div>`};